import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IPerson extends BaseEntity {
    name: string;
}

export class PersonService extends BaseService<IPerson> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'person');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/person.service.ts